import React from 'react';
import PropTypes from 'prop-types';
import ForgotPasswordDialogFooter from './Components/ForgotPasswordDialogFooter';
import ForgotPasswordDialogHeader from './Components/ForgotPasswordDialogHeader';
import ForgotPasswordDialogContent from './Components/ForgotPasswordDialogContent';
import LoginPageWrapper from '../Components/LoginPageWrapper';

import './ForgotPasswordDialog.scss';

function ForgotPasswordDialog({ email, setEmail, closeDialog, isLoading, result, onEmailSubmit, isEmailValid, trackAdobeAnalyticsError }) {
  const [requestSent, setRequestSent] = React.useState(false);

  const submit = () => {
    setRequestSent(true);
    if (!isEmailValid) {
      return;
    }
    onEmailSubmit();
  };

  return (
    <LoginPageWrapper className="react-page-forgot-password-page" mainAriaLabel="Forgot password screen">
      <div className="forgot-password-dialog__content">
        <ForgotPasswordDialogHeader result={result} />
        <ForgotPasswordDialogContent
          isEmailValid={isEmailValid}
          result={result}
          requestSent={requestSent}
          email={email}
          setEmail={setEmail}
          isLoading={isLoading}
          trackAdobeAnalyticsError={trackAdobeAnalyticsError}
        />
        <ForgotPasswordDialogFooter result={result} submit={submit} close={closeDialog} isLoading={isLoading} />
      </div>
    </LoginPageWrapper>
  );
}
ForgotPasswordDialog.propTypes = {
  closeDialog: PropTypes.func.isRequired,
  email: PropTypes.string,
  setEmail: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  result: PropTypes.string,
  isEmailValid: PropTypes.bool,
  trackAdobeAnalyticsError: PropTypes.func.isRequired,
  onEmailSubmit: PropTypes.func.isRequired,
};

export default ForgotPasswordDialog;
